"use strict";
const vue = require("vue");
const _hoisted_1 = {
  fill: "none",
  height: "32",
  viewBox: "0 0 32 32",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ vue.createElementVNode("path", {
  d: "m28.333 28.333-5.981-5.992 5.981 5.992zm-2.666-14a11.33 11.33 0 0 1-3.32 8.014 11.33 11.33 0 0 1-16.028 0 11.332 11.332 0 1 1 19.347-8.014v0z",
  stroke: "currentcolor",
  "stroke-linecap": "round",
  "stroke-width": "2"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function render(_ctx, _cache) {
  return vue.openBlock(), vue.createElementBlock("svg", _hoisted_1, _hoisted_3);
}
const SearchIcon = { render };
exports.SearchIcon = SearchIcon;
